import { Context } from "./jobs-wrapper";
import { useState, useContext } from "react";
import {removeMainCat, getFullState, FriendlyFacetURLs, RemovePageQSFromURL, scrollToTopOfJobs} from '../helpers/helpers.js';

if (typeof window.kw_from_search === 'undefined') window.kw_from_search = "";
if (typeof window.predefined_cats === 'undefined') window.predefined_cats = [];



//handles the hiding of the "faux" dropdown if anything but that is clicked on
document.addEventListener('mouseup', (e) =>{
    if(!e.target.hasAttribute("data-type") && !e.target.hasAttribute("data-drop") && !e.target.hasAttribute("data-select")) {
        //console.log("doesnt have attribute");

        let all_dropdowns = document.querySelectorAll(".custom-multichk-detail");

        all_dropdowns.forEach((el) => {
            el.style.display = "none";
        })
    }
});

const JobSearch = () => {
    const {data, loading, updateJobParams, updatePageIndex} = useContext(Context);
    const [skipKewordFromSearch, setSkipKewordFromSearch] = useState(false); //we dont want to retian KW search ofter first "load"

    if (window.kw_from_search && !loading) {
        if (skipKewordFromSearch === true) {
            window.kw_from_search = "";
        }
        else {
            setSkipKewordFromSearch(true);
        }
    }

    const [inputs, setInputs] = useState({"keywords" : window.kw_from_search}); //retains input information (keyword) - structure: {"keywords":"nurses"}
    const [checkboxes, setCheckboxes] = useState({}); //retains which checkboxes were clicked after a search  - structure:
    const [tags, setTags] = useState([]); //retains checkbox name and value for Tags - structure: [{"name":"cat0","value":"Schools - Adaptive Physical Education Teacher"},{"name":"st0","value":"AK"}]
    const [cityCheckboxValues, setCityCheckboxValues] = useState([]); //sets city dropdowns when a state is clicked - structure: [{"key":"Anchorage","doc_count":19,"state":"AK"},{"key":"Anchorage ","doc_count":1,"state":"AK"}]
    const [stateCheckboxValues, setStateCheckboxValues] = useState([]); //retains state/city list after a filtered search - structure: [{"key":"AK","doc_count":57,"city-list":{"doc_count_error_upper_bound":0,"sum_other_doc_count":0,"buckets":[{"key":"Anchorage","doc_count":19,"state":"AK"},{"key":"Anchorage ","doc_count":1,"state":"AK"},{"key":"Barrow","doc_count":7,"state":"AK"}]
    const [categoryCheckboxValues, setCategoryCheckboxValues] = useState([]); //retains cat list after a filtered search - structure: [{"key":"Schools - Adaptive Physical Education Teacher","doc_count":3,"cleaned_key":"Adaptive Physical Education Teacher"}]
    const [selectLabels, setSelectLabels] = useState({}) //sets the dropdown labels like "(x) selected" - structure: 
    //console.log("outer kw: " + window.kw_from_search)
    //console.log("stateCheckboxValues: " + JSON.stringify(stateCheckboxValues))
    //console.log("categoryCheckboxValues: " + JSON.stringify(categoryCheckboxValues))
    //console.log("cityCheckboxValues: " + JSON.stringify(cityCheckboxValues))
    //console.log("tags: " + JSON.stringify(tags))
    //console.log("inputs " + JSON.stringify(inputs))


    //handles the select labels i.e., (3 Selected)
    const handleSelectLabels = (type, default_string) => {
        let count = 0,
            label = "",
            final_output = "";

        Object.entries(selectLabels).forEach(entry =>{
            const [key, value] = entry;
            if (value === type) {
                count++;
                label = key;
            } 
        })

        if (type === "cat") {
            final_output = (count === 1) ? removeMainCat(label) : `(${count} Selected)`;
        }
        else {
            final_output = `(${count})`;
        }

        return (count>0) ? final_output : default_string;
    }

    //saves dropdown data so when a new search occurs we dont remove the facet data. Only applicable if a filter/facet was checked
    const saveDropDownData = () => {

        data.aggregations.stateslist.buckets?.forEach(state => {
            let check_name_match = obj => obj.key === state.key;
            if (!stateCheckboxValues.some(check_name_match)) setStateCheckboxValues(values => ([...values, state]))
        })

        data.aggregations.categorieslist.buckets?.forEach(cat => {

            //console.log("THE CAT: " + JSON.stringify(cat));
            let check_name_match = obj => obj.key === cat.key;
            if (!categoryCheckboxValues.some(check_name_match)) setCategoryCheckboxValues(values => ([...values, cat]))
        })
    }

    //retains search text field query
    const handleChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        setInputs(values => ({...values, [name]: value}))

    }

    //retains checkbox's checked and does part of the state to city display
    const handleChkChange = (event) => {
        const chkbox = event.target ?? event;
        const name = chkbox.name;
        const type = chkbox.getAttribute("data-type");
        const value = chkbox.value;
        const checked = (chkbox.checked) ? "checked" : "";
        setCheckboxes(values => ({...values, [name]: checked}));


        //works for city/state
        (chkbox.checked) ? setSelectLabels(values => ({...values, [value]: type})) : setSelectLabels(values => {const newData = {...values}; delete newData[value]; return newData});

        //console.log("Select Labels 2 " + JSON.stringify(selectLabels));
        
        /*setData((prevData) => {
            const newData = {...prevData}
            delete newData["key_here"]
            return newData;
          })*/
        

        //handle State Dropdowns to show cities or remove cities 
        if (type === "state") {

            ((stateCheckboxValues.length > 0) ? stateCheckboxValues : data.aggregations.stateslist.buckets).forEach(bucket => {
                if (bucket.key === value) {
                    
                    //console.log("state bucket" + JSON.stringify(bucket));

                    bucket["city-list"]["buckets"].forEach((city, index) => {
                        //add the state name to city
                        city["state"] = bucket.key;

                        //console.log("city bucket: " + JSON.stringify(city));
                        
                        //ether add or remove depending if we checked or unchecked boxes
                        if (event.target.checked) {
                            setCityCheckboxValues(values => ([...values, city]))
                            
                        }
                        else {
                            setCityCheckboxValues(values => values.filter(el => {return el.key !== city.key})); //either add cities or remove them from th data of dropdowns
                            setCheckboxes(values => ({...values, ["city"+index]: ""})); //if we unchcecked the state, we need to uncheck its cities
                            setSelectLabels(values => {const newData = {...values}; delete newData[city.key]; return newData})

                            /* Need Below for City tags
                            *
                            * If a state is removed from the "tags", the associated cities dont remove. The following is needed to uncheck the cities so when handleSubmit runs,
                            * the associated cities are already unchceked. 
                            */
                            if (document.querySelector(`input[name="city${index}"]`)) document.querySelector(`[name="city${index}"]`).checked=false;
                        }
                        

                    })
                } 
            })
        }

        //console.log("city values: " + JSON.stringify(cityCheckboxValues))
        //console.log(JSON.stringify(checkboxes))

        //document.getElementById("SearchSubmit").click();
    }
    
    const handleSubmit = (event) => {
        event.preventDefault()
        RemovePageQSFromURL()
        updatePageIndex(1)

        let search_params = {},
            category_values = [],
            state_values = [],
            city_values = [],
            kw = document.getElementById('search-kw'),
            categories = document.querySelectorAll('.cat-select'),
            states = document.querySelectorAll('.st-select'),
            cities = document.querySelectorAll('.city-select');

        if (inputs.keywords) {
            search_params["keywords"] = inputs.keywords.trim();
            //kw.value = inputs.keywords.trim();
            //setTheTags(kw);
        }

        //console.log("search: " + JSON.stringify(search_params))        
           
        //check if categories were selected and add to an array
        categories.forEach((el) => {
            //console.log("EACH CAT:" + el.value)
            if (el.checked) category_values.push(el.value);
            setTheTags(el);
        })

        //console.log("category_values: " + category_values);

        //check if states were selected and add to an array
        states.forEach((el) => {
            if (el.checked) state_values.push(el.value);
            setTheTags(el);
        })

         //check if cities were selected and add to an array
         cities.forEach((el) => {
            if (el.checked) city_values.push(el.value) 
            //if (el.checked) console.log("This city is checked: " + el.value)
            setTheTags(el);
        })


        //add categories and/or states to search params
        if (category_values.length > 0) search_params["categories"] = category_values 
        if (state_values.length > 0) search_params["states"] = state_values
        if (city_values.length > 0) search_params["cities"] = city_values

        //Only retain dropdown facet data if a facet was selected. we excluded city since if no states are checked, city would not be as well.
        if (category_values.length > 0 || state_values.length > 0) saveDropDownData();    
        
        //update the job params which will trigger search
        //if (Object.keys(search_params).length > 0) updateJobParams(search_params) //this causes blank searches to not work
        updateJobParams(search_params);

        if(window.innerWidth <= 991) scrollToTopOfJobs();
        
    }

    //sets the tags in useState
    const setTheTags = (input) => {
        const name = input.name;
        const value = input.value;
        
        if (name === "keywords") {
            if (value) {
                let check_name_match = obj => obj.name === "keywords";
                
                if (!tags.some(check_name_match)) {
                    //kw tag not found..
                    setTags(values => [...values, {name, value}]);
                    //console.log("tags if : " + JSON.stringify(tags))
                }
                else {
                    //values => {const newData = {...values}; delete newData[value]; return newData}
                    const mapped = tags.map(values => {
                        const newData = {...values};
                        if (newData["name"] === "keywords") newData["value"] = value;
                        return newData;

                    });
                    //kw found, we must replace it
                    setTags(mapped);
                    //console.log("tags else : " + JSON.stringify(tags))
                }
            }
            else {
                //remove kw tag
                setTags(values => values.filter(el => {return el.name !== "keywords"}));
                //console.log("tags else else: " + JSON.stringify(tags))
            }


        }
        else {
            //checkboxes
            if (input.checked) {
                let check_name_match = obj => obj.name === name;
                if (!tags.some(check_name_match)) setTags(values => [...values, {name, value}]);
            }
            else {
                //console.log("tags: " + JSON.stringify(tags))
                setTags(values => values.filter(el => {return el.name !== name}));
            }    
        }
    }


    //handles if the keyword tag was clicked
    const handleKeywordTagClick = () => {
       
        //sets kw field to blank
        setInputs({"keywords" : ""});
        document.getElementById("search-kw").value = "";
        

        document.getElementById("SearchSubmit").click();
    }

    //handles the anchor/tag click of the checkbox dropdown to programatically check or uncheck teh checkbox 
    const handleFakeChkClick = (e, filter_name) => {
        
        //we need to check the cooresponding checkbox 
        e.preventDefault();
            
        //initiate a click event for checkbox 
        document.querySelector(`[data-name="${filter_name}"]`).click()
        // if (e.target.tagName === 'A') {
        //}

        if(e.target.classList.contains('job-search-tag') || e.target.classList.contains('job-search-tag__close')) {
            //console.log("TAG COUNT: " + document.querySelectorAll('.job-search-tag').length)

            //if we remove a tag, we want to initiate a search
            document.getElementById("SearchSubmit").click();

        }
    
    }
    
    //shows the "faux" dropdown 
    const DoMultiChkDropDown = (e, filter_type) => {
        let dropdown = document.querySelector(`[data-drop="${filter_type}"]`);
        let all_dropdowns = document.querySelectorAll(".custom-multichk-detail");

        all_dropdowns.forEach((el) => {
            (el.getAttribute("data-drop") === filter_type && el.style.display === "none") ? el.style.display = "block" : el.style.display = "none";
        });
    
        //(dropdown.style.display === "block") ? dropdown.style.display = "none" : dropdown.style.display = "block";
    }

    const clearAllFilters = () => {
        document.querySelectorAll('input[type="checkbox"]').forEach(el=> {
            if (el.checked) el.click();
        })

        //sets kw field to blank
        document.getElementById("search-kw").value = "";
        setInputs({});

        document.getElementById("SearchSubmit").click();
    }

    const buildSearchTagMarkup = (name, value) => {
        let new_value = "";
        let aria_label = "";

        if(name.includes("cat")) {
            new_value = removeMainCat(value)
        }
        else if(name.includes("st")) {
            new_value = getFullState(value)
        }
        else {
            new_value = value
        }

        aria_label = "Remove " + new_value + " from filter";

        return (
            (name.includes("keywords")) ? <span class="job-search-tag" data-type="kw" onClick={handleKeywordTagClick} aria-label={aria_label} tabindex="0"><span class="job-search-tag__close"></span>{new_value}</span> : <span class="job-search-tag" data-type={name} onClick={e => handleFakeChkClick(e, value)} aria-label={aria_label} tabindex="0"><span class="job-search-tag__close"></span>{new_value}</span>
        )
    }

    const buildCategoryMarkup = () => {
        if (loading && !categoryCheckboxValues.length > 0) {
            return (<div class="jobs-loading"><img src="/wp-content/themes/sunbelt/images/loading.gif" alt="" /><span>Loading..</span></div>)
        }
        else if (categoryCheckboxValues.length > 0) {
            return (
                <div class="custom-multichk-detail-body">
                    {categoryCheckboxValues.map((row, index) => (
                        <div class="cont">
                            <div><input type="checkbox" name={"cat"+index} data-type="cat" data-name={row["key"]} class="mulinput cat-select" value={row["key"]} checked={checkboxes["cat"+index]} onChange={handleChkChange} /></div>
                            <div><a href="javascript:void(0)" data-type="cat" title={row["key"]} onClick={e => handleFakeChkClick(e, row["key"])}>{removeMainCat(row["key"])}  ({row["doc_count"]})</a></div>
                        </div>
                    ))}
                </div>
            )
        }
        else if (!loading && typeof data.hits !== 'undefined') {
            data.aggregations.categorieslist.buckets.forEach((row) => {
                row["cleaned_key"] = removeMainCat(row["key"]); 
            });

            data.aggregations.categorieslist.buckets.sort((a,b)=> (a.cleaned_key.toLowerCase() > b.cleaned_key.toLowerCase() ? 1 : -1)) //sort by alpha

            return (
                <div class="custom-multichk-detail-body">
                    {data.aggregations.categorieslist.buckets?.map((row, index) => (
                        <div class="cont">
                            <div><input type="checkbox" name={"cat"+index} data-type="cat" data-name={row["key"]} class="mulinput cat-select" value={row["key"]} checked={checkboxes["cat"+index]} onChange={handleChkChange} /></div>
                            <div><a href="javascript:void(0)" data-type="cat" title={row["key"]} onClick={e => handleFakeChkClick(e, row["key"])}>{row["cleaned_key"]}  ({row["doc_count"]})</a></div>
                        </div>
                    ))}
                </div>
            )
        }
    }

    const buildStateMarkup = () => {
        if (loading && !stateCheckboxValues.length > 0) {
            return (<div class="jobs-loading"><img src="/wp-content/themes/sunbelt/images/loading.gif" alt="" /><span>Loading..</span></div>)
        }
        else if (stateCheckboxValues.length > 0) {
            return (
                <div class="custom-multichk-detail-body">
                    {stateCheckboxValues.map((row, index) => (
                         <div class="cont">
                            <div><input type="checkbox" name={"st"+index} data-type="state" data-name={row["key"]} class="mulinput st-select" value={row["key"]} checked={checkboxes["st"+index]} onChange={handleChkChange} /></div>
                            <div><a href={FriendlyFacetURLs(window.predefined_cats, getFullState(row["key"]), null)} data-type="state" title={row["key"]} onClick={e => handleFakeChkClick(e, row["key"])}>{getFullState(row["key"])}</a></div>
                        </div>
                    ))}
                </div>
            )
        }
        else if (!loading && typeof data.hits !== 'undefined') {
            return (
                <div class="custom-multichk-detail-body">
                    {data.aggregations.stateslist.buckets?.map((row, index) => (
                         <div class="cont">
                            <div><input type="checkbox" name={"st"+index} data-type="state" data-name={row["key"]} class="mulinput st-select" value={row["key"]} checked={checkboxes["st"+index]} onChange={handleChkChange} /></div>
                            <div><a href={FriendlyFacetURLs(window.predefined_cats, getFullState(row["key"]), null)} data-type="state" title={row["key"]} onClick={e => handleFakeChkClick(e, row["key"])}>{getFullState(row["key"])}</a></div>
                        </div>
                    ))}
                </div>
            )
        }
    }

    return (
        <>
        <section class="job-search bg-blue">
          <div class="container-xl">  
            <div class="row">
              <div class="col-md-12">
                <a class="named-anchor" name="top-of-jobs" id="TopOfJobs"></a>
                {/*console.log("Re-render")*/}
                <form role="search" class="jobs__search-form search-form" onSubmit={handleSubmit} aria-label="Search our jobs">
                    <div class="field-group">	
                        <label for="search-kw">Keyword</label>
                        <input type="search" id="search-kw" class="search-field" placeholder="Job Title" name="keywords" title="Search Jobs by Keyword" value={inputs.keywords}  onChange={handleChange} />
                    </div>
                    <div class="field-group field-group-select">	
                        <label for="search-cat">Category</label>
                        <div class="custom-multichk custom-multichk-type" id="cat-filter" name="search-cat" data-select="cat" onClick={e => DoMultiChkDropDown(e, "cat")} aria-label="Filter by Category" tabindex="0">{handleSelectLabels("cat", "Filter by Category")}</div>
                        <div class="custom-multichk-detail" data-drop="cat" style={{display: 'none'}}>
                            {buildCategoryMarkup()}
                        </div>  
                    </div>
                    <div class="field-group field-group-select">	
                        <label for="search-state">State</label>
                        <div class="custom-multichk custom-multichk-type" id="state-filter" data-select="state" onClick={e => DoMultiChkDropDown(e, "state")} aria-label="Filter by State" tabIndex="0">{handleSelectLabels("state", "ST")}</div>
                        <div class="custom-multichk-detail" data-drop="state" style={{display: 'none'}}>
                            {buildStateMarkup()}
                        </div>
                    </div>
                    {(cityCheckboxValues.length > 0) && (
                        <div class="field-group field-group-select">	
                        <label for="search-cat">City</label>
                        <div class="custom-multichk custom-multichk-type" id="city-filter" data-select="city" onClick={e => DoMultiChkDropDown(e, "city")} aria-label="Filter by City" tabIndex="0">{handleSelectLabels("city", "City")}</div>
                        <div class="custom-multichk-detail" data-drop="city" style={{display: 'none'}}>
                            <div class="custom-multichk-detail-body">
                                {cityCheckboxValues?.map((row, index) => (
                                    <div class="cont">    
                                        <div><input type="checkbox" name={"city"+index} data-type="city" data-name={row["key"]} class="mulinput city-select" value={row["key"]} checked={checkboxes["city"+index]} onChange={handleChkChange} /></div>
                                        <div><a href={FriendlyFacetURLs(window.predefined_cats, getFullState(row["state"]), row["key"])} data-type="city" title={row["key"]} onClick={e => handleFakeChkClick(e, row["key"])} >{row["key"]}, {row["state"]}</a></div>
                                    </div>
                                ))}
                            </div>
                        </div>  
                    </div>
                    )}
                    <input type="submit" class="search-submit" id="SearchSubmit" value="Search All Jobs" />
                </form>
                </div>
            </div>
          </div>
        </section>
        <section class="job-search__tags bg-tan-light">
            <div class="container-xl">  
                <div class="row justify-content-center">
                    <div class="col-lg-10">
                    {(!loading && tags.length > 0) && (
                        <div class="job-search-tags-wrap">
                            {console.log("TAGS FOR MARKUP: " + JSON.stringify(tags))}
                            {tags?.map((row) => (
                                buildSearchTagMarkup(row.name, row.value)
                            ))}
                            <span class="clear-all-tags" onClick={clearAllFilters} aria-label="Clear all filters" tabindex="0">Clear</span>
                        </div>
                    )}
                    </div>    
                </div>    
            </div>
        </section>
        </>
    )
}

export default JobSearch;